import { FinancialOperationService, Loader, localForageHelper, LogService, onUserChange, ToastHelper, User } from '@hub/shared'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './income-report.component.scoped.scss'
import { AxiosError } from 'axios'

const RESPONSIBLE_EMAIL = 'meajuda@squidit.com.br'

interface State {
  loading: boolean
  user: User | null
  urlIncome: string | null
}

export default () => {
  const financialOperationService = useMemo(() => new FinancialOperationService(), [])
  const toast = useMemo(() => new ToastHelper().toast, [])
  const logService = useMemo(() => new LogService(), [])
  logService.init('IncomeReport component')

  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [impersonateObject, setImpersonateObject] = useState<any>(null)
  const [state, setState] = useState<State>({
    loading: false,
    user: null,
    urlIncome: null,
  })

  const { t } = useTranslation('incomeReport')

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe((userChanged: User) => {
      const getIncomeReport = async () => {
        try {
          const response = await financialOperationService?.getIncomeInfoUrl()
          setState((prevState) => ({ ...prevState, urlIncome: response?.url || null }))
        } catch (error: AxiosError | any) {
          if (error?.data?.code !== 'FO029') {
            logService.error({ message: 'Unable to fetch income information', error })
            toast.error(t('error'), {
              closeButton: true,
              className: 'full',
              position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
              duration: 3600000,
              notOverClick: true,
              immediately: true,
            })
          }
        }
      }

      const oldUser = state?.user
      setState((prevState) => ({ ...prevState, user: userChanged }))

      if (!oldUser?.squidId && userChanged?.squidId) {
        getIncomeReport()
      }
    })

    return onUserChangeSubscription.current.unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    localForageHelper.getItem('impersonateUser').then((impersonateUser) => setImpersonateObject(impersonateUser))
  }, [])

  const year = useMemo(() => new Date().getFullYear().toString(), [])

  if (state?.loading) {
    return (
      <div className="text-center" style={{ width: '100%' }}>
        <Loader size="big" />
      </div>
    )
  }

  return (
    (!impersonateObject || impersonateObject?.impersonateAdmin) && (
      <>
        {state?.urlIncome ? (
          <div className="income-report">
            <a href={state?.urlIncome} target={'_blank'}>
              <i className="fa-solid fa-lines mr-2"></i>
              <span
                dangerouslySetInnerHTML={{ __html: t('incomeReportMessage', { referenceYear: `${parseInt(year.slice(-2)) - 1}/${year}` }) }}
              />
            </a>
          </div>
        ) : null}
      </>
    )
  )
}
